<template>
    <page class="c-dashboard">
        <slider :currentPage="currentPage" />
        <div v-if="isLoggedIn" class="-loggedin">
            <ion-grid>
                <ion-row>
                    <ion-col>
                        <h4 class="ion-text-center c-dashboard__headline">
                            Meine Produkte
                        </h4>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <template
                        v-if="typeof $store.state.checklists === 'object'"
                    >
                        <ion-col
                            size-md="6"
                            size="12"
                            style="padding-bottom: 0; padding-top: 0;"
                            v-for="(checklist, key) in $store.state.checklists"
                            :key="key"
                        >
                            <contract-icon-card
                                :isKreditcheckliste="true"
                                :date="checklist.date"
                                :description="checklist.description"
                                :checklistKey="key"
                            ></contract-icon-card>
                        </ion-col>
                    </template>
                    <template
                        v-for="(contract, contractKey) in $store.state
                            .contracts"
                    >
                        <ion-col
                            size-md="6"
                            size="12"
                            :key="contractKey"
                            style="padding-bottom: 0; padding-top: 0;"
                        >
                            <contract-icon-card
                                :contractId="contract.ContractId"
                            ></contract-icon-card>
                        </ion-col>
                    </template>
                    <!-- <template
                    v-for="(motiveConfig, motiveKey) in $store.state
                        .motivesConfig"
                >
                    <ion-col
                        size="4"
                        v-if="motiveHasContracts(motiveConfig.motive)"
                        :key="motiveKey"
                    >
                        <pagelink
                            :path="'/' + motiveConfig.path"
                            :motiveclass="{ ['-' + motiveConfig.path]: true }"
                            :icon="'icon-' + motiveKey"
                            :title="motiveConfig.title"
                        />
                    </ion-col>
                </template> -->
                    <!-- <ion-col size="4" :key="'gesundheit'">
                    <pagelink
                        :path="'/gesundheit'"
                        :motiveclass="{ ['-gesundheit']: true }"
                        :icon="'icon-gesundheit'"
                        :title="'Gesundheit'"
                    />
                </ion-col> -->
                    <!-- <ion-col size="4">
                    <pagelink
                        :path="{ name: 'services' }"
                        icon="icon-services"
                        title="Services"
                    />
                </ion-col> -->
                </ion-row>
                <ion-row>
                    <ion-col>
                        <h4 class="ion-text-center c-dashboard__headline">
                            Meine Services
                        </h4>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col size="3">
                        <pagelink
                            :path="{ name: 'berater' }"
                            icon="icon-berater"
                            title="Berater"
                        />
                    </ion-col>
                    <ion-col size="3">
                        <pagelink
                            :path="{ name: 'schadensmeldung' }"
                            icon="icon-schadensmeldung"
                            title="Schadensmeldung"
                        />
                    </ion-col>
                    <ion-col size="3">
                        <pagelink
                            :path="{ name: 'dokbox' }"
                            icon="icon-dokbox"
                            title="DokBox"
                        />
                    </ion-col>
                    <ion-col size="3" v-if="hasFeature('Unwetter')">
                        <pagelink
                            :path="{ name: 'services-unwetterwarnung' }"
                            icon="icon-unwetterwarnung"
                            title="Unwetterwarnung"
                        />
                    </ion-col>
                    <!-- <ion-col size="3" v-if="platforms.includes('mobile')">
                        <pagelink
                            :path="{ name: 'immowert' }"
                            icon="flame"
                            title="ImmoWert berechnen"
                        />
                    </ion-col> -->
                    <ion-col size="3" v-if="hostname === 'localhost'">
                        <pagelink
                            :path="false"
                            icon="flame"
                            title="QR Scanner"
                            @click.native="scanBarcode()"
                        />
                    </ion-col>
                    <!-- <ion-col
                        size="3"
                        v-if="
                            $store.getters[
                                'contractsDetails/hasMobilitaetsSchutzPlus'
                            ]
                        "
                    >
                        <pagelink
                            :path="{ name: 'services-biketrax' }"
                            icon="flame"
                            title="eBike Tracker"
                        />
                    </ion-col> -->
                    <ion-col size="3">
                        <pagelink
                            :path="false"
                            icon="flame"
                            title="Newsletter"
                            @click.native="openNewsletterModal()"
                        />
                    </ion-col>
                    <ion-col size="3">
                        <pagelink
                            :path="{ name: 'me1ns' }"
                            icon="flame"
                            title="me1ns"
                        />
                    </ion-col>
                    <!-- <ion-col size="3">
                        <pagelink
                            path="https://www.klickmal.at/pages/lebenscheck.html"
                            icon="icon-lebenscheck"
                            title="LebensCheck"
                        />
                    </ion-col> -->
                    <ion-col size="3">
                        <pagelink
                            path="https://www.mein-leben.at"
                            icon="icon-berater"
                            title="Magazin"
                        />
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <template v-else>
            <ion-grid no-padding>
                <ion-row>
                    <ion-col size="4">
                        <pagelink
                            :path="{ name: 'schadensmeldung' }"
                            icon="flame"
                            title="Schadensmeldung"
                        />
                    </ion-col>
                    <!-- <ion-col size="4" v-if="platforms.includes('mobile')">
                        <pagelink
                            :path="{ name: 'immowert' }"
                            icon="flame"
                            title="ImmoWert berechnen"
                        />
                    </ion-col> -->
                    <ion-col size="4" v-if="hostname === 'localhost'">
                        <pagelink
                            :path="false"
                            icon="flame"
                            title="QR Scanner"
                            @click.native="scanBarcode()"
                        />
                    </ion-col>
                    <ion-col size="4">
                        <pagelink
                            :path="{ name: 'me1ns' }"
                            icon="flame"
                            title="me1ns"
                        />
                    </ion-col>
                    <!-- <ion-col size="4">
                        <pagelink
                            :path="{ name: 'services-biketrax' }"
                            icon="flame"
                            title="eBike Tracker"
                        />
                    </ion-col> -->
                    <!-- <ion-col size="4">
                        <pagelink
                            path="https://www.klickmal.at/pages/lebenscheck.html"
                            icon="flame"
                            title="Lebenscheck"
                        />
                    </ion-col> -->
                    <ion-col size="4">
                        <pagelink
                            path="https://www.mein-leben.at"
                            icon="flame"
                            title="Magazin"
                        />
                    </ion-col>
                    <ion-col size="4">
                        <pagelink
                            path="https://www.klickmal.at/pages/kontakt.html?zone=allgemein&tab=berater"
                            icon="flame"
                            title="Beratersuche"
                        />
                    </ion-col>
                    <!-- <ion-col size="4">
                        <pagelink
                            path="https://www.klickmal.at/wohnen/immoflexkredit/wohntraumzuckerl.html"
                            icon="flame"
                            title="Weiterempfehlen"
                        />
                    </ion-col> -->
                    <!-- <ion-col size="4">
                        <pagelink
                            :path="{ name: 'einstellungen' }"
                            icon="flame"
                            title="Einstellungen"
                        />
                    </ion-col> -->
                    <!-- <ion-col size="4">
            <pagelink
              path="https://www.klickmal.at/pages/impressum.html"
              icon="flame"
              title="Impressum"
            />
          </ion-col> -->
                    <!-- <ion-col size="4">
            <pagelink
              path="https://haroldkhan62143.invisionapp.com/public/share/DFWTON6YE#/screens"
              icon="flame"
              title="App Demo"
            />
          </ion-col> -->
                </ion-row>
            </ion-grid>
        </template>
    </page>
</template>

<script>
import Page from "@/components/Page";
import Slider from "@/components/Slider";
import Pagelink from "@/components/Pagelink";
import "capacitor-secure-storage-plugin";
import { Plugins } from "@capacitor/core";
import { FingerprintAIO } from "@ionic-native/fingerprint-aio";
import { handleError } from "@/utils/error";
import ContractIconCard from "@/components/ContractIconCard";
import { BarcodeScanner } from "@ionic-native/barcode-scanner";
import QRCodeModal from "@/components/QRCodeModal";
import NewsletterModal from "@/components/NewsletterModal";

const { SecureStoragePlugin, Storage } = Plugins;
const faio = FingerprintAIO;
const barcodeScanner = BarcodeScanner;

export default {
    components: { Page, Slider, Pagelink, ContractIconCard },
    props: {
        user: {
            type: String,
            required: false,
            default: "",
        },
        password: {
            type: String,
            required: false,
            default: "",
        },
    },
    data() {
        return {
            currentPage: "dashboard",
            hostname: window.location.hostname,
            platforms: Ionic.platforms,
        };
    },
    watch: {
        isLoggedIn() {
            this.checkCurrentPage();
        },
        contracts() {
            this.checkHasMobilitaetsSchutzPlus();
        },
    },
    mounted() {
        this.checkCurrentPage();
        this.checkHasMobilitaetsSchutzPlus();
        Storage.get({ key: "fingerprint" }).then(({ value: val }) => {
            if (val !== "false" && this.user !== "") {
                SecureStoragePlugin.get({ key: this.user })
                    .then((result) => {
                        if (this.password !== result.value) {
                            this.verifyFingerprint();
                        }
                    })
                    .catch(() => {
                        this.verifyFingerprint();
                    });
            }
        });
    },
    computed: {
        isLoggedIn() {
            return this.$store.state.isLoggedIn;
        },
        contracts() {
            return this.$store.state.contracts;
        },
    },
    methods: {
        openNewsletterModal() {
            this.$ionic.modalController
                .create({
                    component: NewsletterModal,
                    componentProps: {
                        propsData: {},
                        parent: this,
                    },
                })
                .then((m) => m.present());
        },
        checkHasMobilitaetsSchutzPlus() {
            for (let key in this.$store.state.contracts) {
                const contract = this.$store.state.contracts[key];
                if (contract.Features.EbikeTracker) {
                    this.$store.cache.dispatch(
                        "contractsDetails/getContractDetails",
                        key
                    );
                }
            }
        },
        hasFeature(feature) {
            let result = false;
            let contracts = this.$store.state.contracts;
            for (let key in contracts) {
                if (
                    contracts[key].hasOwnProperty("Features") &&
                    contracts[key].Features.hasOwnProperty(feature)
                ) {
                    result = true;
                    break;
                }
            }
            return result;
        },
        scanBarcode() {
            // console.log("scan barcode");
            // let barcodeData = {};
            // barcodeData.text = "smsto:077777777777777:SMS Content";
            // this.$ionic.modalController
            //             .create({
            //                 component: QRCodeModal,
            //                 componentProps: {
            //                     propsData: {
            //                         qrCode: barcodeData.text.trim()
            //                     },
            //                     parent: this
            //                 }
            //             })
            //             .then(m => m.present());
            //             return;

            barcodeScanner
                .scan({
                    preferFrontCamera: false, // iOS and Android
                    showFlipCameraButton: true, // iOS and Android
                    showTorchButton: true, // iOS and Android
                    torchOn: false, // Android, launch with the torch switched on (if available)
                    saveHistory: true, // Android, save scan history (default false)
                    prompt:
                        "Positioniere den QR Code innerhalb des Rechteckes.", // Android
                    resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
                    formats: "QR_CODE", // default: all but PDF_417 and RSS_EXPANDED
                    orientation: "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
                    disableAnimations: true, // iOS
                    disableSuccessBeep: true, // iOS and Android
                })
                .then((barcodeData) => {
                    // console.log("Barcode data", barcodeData);
                    if (barcodeData.text && barcodeData.text !== "") {
                        this.$ionic.modalController
                            .create({
                                component: QRCodeModal,
                                componentProps: {
                                    propsData: {
                                        qrCode: barcodeData.text.trim(),
                                    },
                                    parent: this,
                                },
                            })
                            .then((m) => m.present());
                    }
                })
                .catch((err) => {
                    handleError(err);
                });
        },
        checkCurrentPage() {
            if (this.isLoggedIn) {
                this.currentPage = "dashboardLoggedIn";
            } else {
                this.currentPage = "dashboard";
            }
        },
        verifyFingerprint() {
            faio.isAvailable()
                .then((result) => {
                    let authType = "Fingerprint";
                    if (result === "face") {
                        authType = "Face ID";
                    }
                    this.$ionic.alertController
                        .create({
                            header: "Passwort mit " + authType + " verknüpfen",
                            message:
                                "Möchtest du dieses Passwort mit " +
                                authType +
                                " verknüpfen? Damit sparst du dir Zeit beim Login.",
                            buttons: [
                                {
                                    text: "Nein",
                                    role: "cancel",
                                },
                                {
                                    text: "Ja",
                                    handler: () => {
                                        faio.show({
                                            clientId: "Fingerprint-Wuestenrot", //Android: Used for encryption. iOS: used for dialogue if no `localizedReason` is given.
                                            clientSecret:
                                                "qJ#HBa62}qy]m#p<kqxL", //Necessary for Android encrpytion of keys. Use random secret key.
                                            disableBackup: true, //Only for Android(optional)
                                            localizedFallbackTitle:
                                                "Pin benutzen", //Only for iOS
                                            localizedReason:
                                                "Bitte authentifizieren", //Only for iOS
                                        })
                                            .then(() => {
                                                SecureStoragePlugin.set({
                                                    key: this.user,
                                                    value: this.password,
                                                });
                                            })
                                            .catch((error) =>
                                                handleError(error)
                                            );
                                    },
                                },
                            ],
                        })
                        .then((a) => a.present());
                })
                .catch((error) => handleError(error));
        },
        motiveHasContracts(motive) {
            var result = false;
            // Check if checklist available or if any contract in motives
            if (
                (motive === "Mein Zuhause" &&
                    typeof this.$store.state.checklists === "object" &&
                    Object.keys(this.$store.state.checklists).length > 0) ||
                (motive in this.$store.getters.motives &&
                    this.$store.getters.motives[motive].length > 0)
            ) {
                result = true;
            }
            return result;
        },
    },
    // computed: {
    //   title() {
    //     let result = "Dashboard";
    //     if ("vorname" in this.$store.state.userdetails) {
    //       result = "Hallo " + this.$store.state.userdetails.vorname;
    //     }
    //     return result;
    //   }
    // }
};
</script>

<style lang="scss">
.c-dashboard {
    &__headline {
        // font-weight: bold;
        text-align: left !important;
    }

    .-loggedin {
        .c-pagelink {
            padding: var(--gangl-padding-small) var(--gangl-padding-xsmall);
            min-height: 70px;
            &__text {
                font-size: small;
            }
            &__iconcontainer {
                margin-bottom: var(--gangl-padding-xsmall);
            }
            [class^="icon-"],
            [class*=" icon-"] {
                font-size: large;
                line-height: 1.1;
            }
        }
    }
}
</style>
